import React from 'react'
import { GameBrand } from '@precisionpros/game-ui'

const game = {
  name: 'Event',
  wordmarkMain: 'Event',
  wordmarkAccent: 'Pro',
  badge: 'E',
  accent: '#ea580c',
}

export default function EventProBrand({ size = 'header', markOnly = false, className = '' }) {
  return <GameBrand game={game} size={size} markOnly={markOnly} className={className} />
}

export { game as eventProGame }
